import React from 'react'
import { IconProps } from '../../../common/types'

const InstitutionIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
    >
      <g clipPath="url(#clip0_1_9563)">
        <path
          d="M22.6432 10.6989L14.8932 6.76332C14.5785 6.60331 14.2055 6.60331 13.8909 6.76332L6.14089 10.6989C5.76896 10.8875 5.53488 11.2692 5.53488 11.686V14.3933H7.74916V19.929H11.0706V14.3933H12.7313V19.929H16.0527V14.3933H17.7134V19.929H21.0349V14.3933H23.2492V11.686C23.2492 11.2692 23.0151 10.8875 22.6432 10.6989ZM8.11644 12.179L14.392 8.9922L20.6676 12.179H8.11644Z"
          fill="white"
        />
        <path
          d="M21.0349 21.0361H7.74916C6.52795 21.0361 5.53488 22.0292 5.53488 23.2504V24.3576H23.2492V23.2504C23.2492 22.0292 22.2561 21.0361 21.0349 21.0361Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_9563">
          <rect width="28" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default InstitutionIcon
